import React from 'react';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';
import MyBooksPage from '../../../subsreens/gcstaff/staffbookspage/MyBooksPage';



const StaffMyBooks = () => {
    return(
       <TeacherMasterLayout>
       <MyBooksPage></MyBooksPage>
       </TeacherMasterLayout>
    )
}

export default StaffMyBooks;